import type { ReactNode } from "react";
import { Link } from "react-router";

type LegalRouteLinkProps = {
  href: string;
  className?: string;
  children: ReactNode;
};

/** In-app legal routes use React Router; external URLs open in a new tab. */
export function LegalRouteLink({ href, className, children }: LegalRouteLinkProps) {
  if (href.startsWith("/")) {
    return (
      <Link to={href} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <a href={href} className={className} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}
